var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdficon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.275,
    height: 40.469,
    viewBox: "0 0 30.275 40.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-1.462 -0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7475-3",
    d: "M31.736,12.7V35.875A5.2,5.2,0,0,1,26.468,41H6.73a5.2,5.2,0,0,1-5.268-5.121V5.651A5.2,5.2,0,0,1,6.73.529H19.278Z",
    transform: "translate(0 0)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6360-9",
    d: "M19.253.627c-1.01,2.6-3.348,6.587-.991,9.938.613.929,4.343,2.366,6.685,3.2a4.3,4.3,0,0,1,2.724,3.786l.2,15.469a5.194,5.194,0,0,1-5.266,5.12H2.863a5.422,5.422,0,0,1-1.273-.152,5.3,5.3,0,0,0,4.567,2.578H25.9a5.2,5.2,0,0,0,5.269-5.123V12.262Z",
    transform: "translate(0.573 0.437)",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7319-7",
    d: "M6.141.529,4.5,6.927A3.117,3.117,0,0,0,4.939,9.44a3.259,3.259,0,0,0,2.185,1.392L18.6,12.7Z",
    transform: "translate(13.138 0)",
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path395410",
    d: "M12.781,3.477a2.474,2.474,0,0,0-1.773.9,3.119,3.119,0,0,0-.486,2.841,12.926,12.926,0,0,0,1.314,3.207c.067.123.141.207.211.331a55.742,55.742,0,0,1-4.289,6.454c-1.87.444-3.659.662-4.734,1.873a2.481,2.481,0,0,0,0,3.452,2.426,2.426,0,0,0,1.516.562,2.368,2.368,0,0,0,1.217-.342c1.257-.767,2.075-2.4,2.981-4.28l7.347-1.712c1.1,1.366,2.249,2.706,3.616,3.128a3,3,0,0,0,1.9-.044,2.31,2.31,0,0,0,1.413-1.3,2.514,2.514,0,0,0-1.194-3.128,6.248,6.248,0,0,0-3.239-.509c-.632.027-1.3.1-1.978.193-.8-1.221-1.88-2.835-2.82-4.406a13.606,13.606,0,0,0,1.238-3.163,3.691,3.691,0,0,0-.442-3.031,2.108,2.108,0,0,0-1.8-1.018Zm.6,1.893a2.264,2.264,0,0,1,.178,1.846,12.306,12.306,0,0,1-.708,1.77,11.337,11.337,0,0,1-.875-2.1,1.827,1.827,0,0,1,.146-1.516.733.733,0,0,1,.608-.388.777.777,0,0,1,.65.388Zm-.453,6.767c.7,1.122,1.454,2.289,2.066,3.236l-4.915,1.194c.991-1.5,2.032-3.039,2.85-4.43Zm8.175,4.588A.957.957,0,0,1,21.611,18c-.185.478-1.076.607-1.469.465a9.01,9.01,0,0,1-2.18-1.969,3.763,3.763,0,0,1,.688-.1,5.381,5.381,0,0,1,2.455.331ZM6.418,19.279a11.194,11.194,0,0,1-1.448,2.2.73.73,0,0,1-.927-.056,1,1,0,0,1,.111-1.349,4.07,4.07,0,0,1,2.265-.8Z",
    transform: "translate(3.849 13.155)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdficon);
export default __webpack_public_path__ + "static/media/pdficon.7bfb3c0e0ed3900d9990466a7e7845f1.svg";
export { ForwardRef as ReactComponent };